<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form class="needs-validation" [formGroup]="selectform">
      <div class="row d-flex justify-content-between align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h4
            class="card-title m-0 offcanvas-header-text d-flex align-items-center"
          >
            Enable Review
            <i
              class="mdi mdi-information-outline font-size-16 ms-1"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Enable you to Adverts."
            ></i>
          </h4>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <ui-switch
            [color]="offcanvasColors.activeColor"
            [switchColor]="offcanvasColors.switchColor"
            [defaultBgColor]="offcanvasColors.bgColor"
            [defaultBoColor]="offcanvasColors.borderColor"
            [checkedTextColor]="offcanvasColors.activeTextColor"
            [uncheckedTextColor]="offcanvasColors.offTextColor"
            uncheckedLabel="Off"
            [checked]="selectform?.get('enable_review')?.value"
            checkedLabel="On"
            size="small"
            class="me-1"
            (change)="toggleReview($event)"
          ></ui-switch>
        </div>
      </div>

      <div *ngIf="selectform?.get('enable_review')?.value" class="row mt-3">
        <div *ngFor="let layout of layouts" class="col-md-3 col-sm-4 col-6">
          <span class="text-center offcanvas-header-text mb-2 font-size-12 d-flex flex-column justify-content-center fw-semibold">{{ layout.title }}</span>
          <div class="mb-2">
            <label class="card-radio-label">
              <input
                type="radio"
                name="currency"
                [id]="layout.id"
                class="card-radio-input"
                (change)="selectLayeout(layout)"
                [checked]="
                  layout.id === selectform?.get('review_style').value
                "
              />
              <div class="card-radio p-0">
                <div class="d-flex flex-column justify-content-center">
                  <img [src]="layout.image" />
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
